import { render, staticRenderFns } from "./basicLayout.vue?vue&type=template&id=3219e83e"
import script from "./basicLayout.vue?vue&type=script&lang=js"
export * from "./basicLayout.vue?vue&type=script&lang=js"
import style0 from "./basicLayout.vue?vue&type=style&index=0&id=3219e83e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports